import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { useDynamicViewportMeta } from "../hooks/useDynamicViewportMeta";
import AccessDenied from "../pages/AccessDenied";
import AuthPageWrapper from "../pages/AuthPage/AuthPageWrapper";
import {
  ChangePasswordForm,
  GetTokenForm,
  LoginForm,
  RegisterForm,
  ResetPasswordForm,
  VerifyCodeForm
} from "../pages/AuthPage/components";
import { VerifyCodeTypes } from "../pages/AuthPage/types";
import { MainPage } from "../pages/MainPage/MainPage";
import YnaProPaymentPage from "../pages/YnaProPaymentPage";
import PaymentThankYouPage from "../pages/PaymentThankYouPage";
import { MobileConnectedServices } from "../pages/MobileConnectedServices";
import { Loader } from "../ui/Loader/Loader";
import RequireAuth from "../utils/RequireAuth";
import { ROUTES } from "../constants/routes";
import {MobilePayments} from "../pages/MobilePayments";
import {MobileSubscriptionsManage} from "../pages/MobilePayments/manage";
import {CancelPaymentSubscribePage} from "../pages/MobilePayments/CancelPaymentSubscribePage";

// Lazy load тяжелых страниц - они загружаются только при переходе
const DashboardPage = lazy(
  () => import("../pages/DashboardPage/DashboardPage")
);
const TrainAnalysis = lazy(() => import("../pages/TrainAnalysis"));
const AddMeToCoach = lazy(() => import("../pages/AddMeToCoach"));

const App = () => {
  useDynamicViewportMeta();
  return (
    <Suspense fallback={<Loader open={true} />}>
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route
          path={ROUTES.YNA_PRO_PAYMENT}
          element={
            <RequireAuth>
              <YnaProPaymentPage />
            </RequireAuth>
          }
        />
        <Route
          path={ROUTES.PAYMENT_THANK_YOU}
          element={<PaymentThankYouPage />}
        />
        <Route path={ROUTES.LOGIN} element={<AuthPageWrapper />}>
          <Route index element={<LoginForm />} />
          <Route path="register" element={<RegisterForm />} />
          <Route path="verify-code" element={<VerifyCodeForm type={VerifyCodeTypes.registration} />} />
          <Route path="restore-pwd-verify-code" element={<VerifyCodeForm type={VerifyCodeTypes.restorePassword} />} />
          <Route path="reset-password" element={<GetTokenForm />} />
          <Route path="new-password" element={<ResetPasswordForm />} />
          <Route path="change-password" element={<ChangePasswordForm />} />
        </Route>
        <Route
          path="/analysis/:id"
          element={
            <RequireAuth>
              <TrainAnalysis />
            </RequireAuth>
          }
        />
        <Route
          path="/dashboard"
          element={
            <RequireAuth>
              <DashboardPage />
            </RequireAuth>
          }
        />

        <Route
          path="/dashboard/:athleteId"
          element={
            <RequireAuth>
              <DashboardPage />
            </RequireAuth>
          }
        />
        <Route
          path="addmetocoach/:linkId"
          element={
            <RequireAuth>
              <AddMeToCoach />
            </RequireAuth>
          }
        />
        <Route path="accessDenied" element={<AccessDenied />} />
        <Route
          path="linked-services-mobile/:token"
          element={<MobileConnectedServices />}
        />
        <Route
          path="payments-mobile/:selectedPlanId/:token"
          element={<MobilePayments />}
        />
        <Route
          path="manage-payments-mobile/:selectedPlanId/:token"
          element={<MobileSubscriptionsManage />}
        />
        <Route
          path="payments-mobile/cancel-payments-mobile/:dateUntil/:token"
          element={<CancelPaymentSubscribePage />}
        />
      </Routes>
    </Suspense>
  );
};

export default App;
